// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getExamById } from "../api";
import { ExamType } from "../types";

export const useExamById = (
  clinicId: string | undefined,
  payload: { patientId: string; examId: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ExamType>({
    queryKey: ["exams", payload.examId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getExamById(
        token,
        clinicId,
        payload.patientId,
        payload.examId,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the reports page
  });
};
